import React from 'react';
import Reveal from './Reveal';

interface SectionHeadingProps {
  index: string;
  label: string;
  title: React.ReactNode;
  lede?: string;
  align?: 'left' | 'center';
}

/** Editorial section header: numbered label, serif title, optional lede. */
const SectionHeading: React.FC<SectionHeadingProps> = ({
  index,
  label,
  title,
  lede,
  align = 'left',
}) => (
  <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-3xl'}>
    <Reveal>
      <div
        className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}
      >
        <span className="font-mono text-[11px] tracking-label text-peri-400">{index}</span>
        <span className="h-px w-8 bg-white/20" />
        <span className="label">{label}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="display-tight mt-6 text-[38px] text-paper sm:text-[52px] lg:text-[60px]">
        {title}
      </h2>
    </Reveal>
    {lede && (
      <Reveal delay={0.16}>
        <p
          className={`mt-6 text-[16.5px] leading-relaxed text-paper/60 ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        >
          {lede}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
